"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PaginationControls;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function PaginationControls(_ref) {
  var {
    totalPages,
    currentPage,
    setCurrentPage
  } = _ref;
  var handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      window.scrollTo(0, 0);
    }
  };
  var handlePageChange = e => {
    var page = Number(e.target.value);
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      window.scrollTo(0, 0);
    } else {
      setCurrentPage(1);
    }
  };
  var handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      window.scrollTo(0, 0);
    }
  };
  if (!totalPages) return false;else {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "pagination-controls mm-text-center"
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
      onClick: handlePreviousPage,
      disabled: currentPage <= 1
    }, "<"), /*#__PURE__*/_react.default.createElement("span", {
      className: "pagination-text"
    }, "Page", /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
      inputMode: "numeric",
      value: currentPage,
      onChange: handlePageChange,
      "aria-label": "Page input",
      className: "pagination-input",
      onWheel: e => e.target.blur(),
      htmlSize: "2"
    }), "of ", totalPages), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
      onClick: handleNextPage,
      disabled: currentPage >= totalPages
    }, ">"));
  }
}